import { useNavigationContext } from '../../../contexts/NavigationContext';
import MainLayout from '../../../components/Display/MainLayout';
import AttendeesPage from './Attendees/AttendeesPage';
import EventPage from './Events/EventPage';
import PopUpPage from './PopUp/PopUpPage';
import './MaisonMousse.scss';

function Home() {
  const { navigationContext } = useNavigationContext();

  return (
    <MainLayout enableAnalytics={true} scope={'maisonmousse'} websiteLabel={'maisonmousse.fr'}>
      <EventPage isActive={navigationContext.activeAppKey === 'mmevent'} />
      <AttendeesPage isActive={navigationContext.activeAppKey === 'attendees'} />
      <PopUpPage isActive={navigationContext.activeAppKey === 'popup'} />
    </MainLayout>
  );
}

export default Home;
